import { render, staticRenderFns } from "./InvoicesReports.vue?vue&type=template&id=33e9d1d8"
import script from "./InvoicesReports.vue?vue&type=script&lang=js"
export * from "./InvoicesReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports